module.exports = __webpack_public_path__ + "img/1spade-05.00228fa2.svg";